import { render, staticRenderFns } from "./InsuranceTypesList.vue?vue&type=template&id=2985ff85"
import script from "./InsuranceTypesList.vue?vue&type=script&lang=js"
export * from "./InsuranceTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports